import { jsx as _jsx } from "react/jsx-runtime";
import RealMoney from './RealMoney';
import PlayMoney from './PlayMoney';
import PrizeBundle from './PrizeBundle';
const Currency = ({ currency, rewardType, payoutTemplate, amount, className, optimise = false, haveResponsive = false, showCompactVersion = false, hideIcon = false, withDollarSymbol = false, iconSize, iconGap, applyStacking, }) => {
    if ((payoutTemplate === null || payoutTemplate === void 0 ? void 0 : payoutTemplate.type) === 'prize-bundle' && payoutTemplate.prizing_summary) {
        return (_jsx(PrizeBundle, { haveResponsive: haveResponsive, showCompactVersion: showCompactVersion, prizingSummary: payoutTemplate.prizing_summary, applyStacking: applyStacking }));
    }
    switch (currency) {
        case 'USD':
            return (_jsx(RealMoney, { rewardType: rewardType, withDollarSymbol: withDollarSymbol, optimise: optimise, className: className, amount: amount, hideIcon: hideIcon, iconSize: iconSize, iconGap: iconGap }));
        case 'PM':
            return (_jsx(PlayMoney, { optimise: optimise, className: className, amount: amount, hideIcon: hideIcon, iconSize: iconSize, iconGap: iconGap }));
        default:
            return null;
    }
};
export default Currency;
